import { Checkbox, TooltipHost } from "@fluentui/react";
import React, { useContext, useMemo } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";

type Props = { className?: string };

export const SelectAllCheckbox = ({ className }: Props) => {
  const { columns, onDeselectAll, onSelectAll, strings, id } =
    useContext(ColumnOptionsContext);
  const areAllVisible = useMemo(() => {
    return !columns.some((c) => !c.isVisible && !c.isFixed);
  }, [columns]);

  const tooltipLabel = areAllVisible
    ? strings.visibilityDeselectAllTitle
    : strings.visibilitySelectAllTitle;

  return (
    <TooltipHost content={tooltipLabel}>
      <Checkbox
        id={id ? `${id}-checkbox-all` : undefined}
        className={className}
        label={tooltipLabel}
        onChange={() => {
          if (areAllVisible) {
            onDeselectAll();
          } else {
            onSelectAll();
          }
        }}
        checked={areAllVisible}
        styles={{ root: { marginLeft: 4 } }}
      />
    </TooltipHost>
  );
};
